"use client";

import React, { useEffect, useState } from "react";
import { FaAngleUp } from "react-icons/fa6";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed z-40 left-auto items-center justify-center flex w-10 h-10 text-white duration-300 ease-in-out rounded-md shadow-md back-to-top bottom-8 right-8 bg-primary hover:bg-primary/80"
        >
          <FaAngleUp
            style={{
              fontSize: 24
            }}
          />
        </button>
      )}
    </>
  );
}
